import styled, { css } from "styled-components";
import { Flex, Text, Box } from "rebass/styled-components";

import { FormLink } from "../../../Components/Form/Link";

export const ExternalLink = styled(FormLink)`
  cursor: pointer;
  font-size: 16px;
  color: ${(props) => props.theme.colors.ice};
  display: inline-flex;
`;

export const AddOnGrid = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`;

export const AddOnRow = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.darkNebula || theme.colors.navy};
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  justify-content: space-between;
  padding: 12px 16px;
`;

export const AddOnClips = styled(Text)`
  color: ${({ theme }) => theme.colors.envy};
  font-family: Barlow;
  font-size: 15px;
  font-weight: 600;
`;

export const AddOnPrice = styled(Text)`
  color: ${({ theme }) => theme.colors.chalk};
  font-family: Barlow;
  font-size: 14px;
`;
